import { graphql } from "@opensea/graphql"

export const CancelOrderTableHeaderFragment = graphql(`
  fragment CancelOrderTableHeader on Order {
    side
  }
`)
